import OrderedArray from './collections/ordered-array';

export default {
	OrderedArray
};